import { Component, inject, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferPartnerDTO } from 'src/app/models/TransferPartnerDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { UserGroupDTO } from 'src/app/models/UserGroupDTO.model';
import { UserPartnerDTO } from 'src/app/models/UserPartnerDTO.model';
import { PartnersService } from 'src/app/services/partners.service';
import { Alert } from 'src/app/shared/models/Alert';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { AlertService } from 'src/app/shared/services/alert.service';
import { saveAs } from 'file-saver';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from '../../../pipes/search.pipe';
import { SearchModalPipe } from '../../../pipes/search-modal.pipe';
import { ValidatePermissionsService } from '../../../shared/services/validate-permissions.service';

@Component({
    selector: 'app-list-partner-customers',
    templateUrl: './list-partner-customers.component.html',
    styleUrls: ['./list-partner-customers.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        SearchPipe,
        SearchModalPipe
    ]
})
export class ListPartnerCustomersComponent implements OnInit, OnChanges {
  @Input() partnerDataInput: UserDTO = {} as UserDTO;
  @Input() readOnly = false;
  partners: UserPartnerDTO[] = [];
  customersAssigned: UserPartnerDTO[] = [];
  customersAvailables: UserPartnerDTO[] = [];
  partnersAvailables: TransferPartnerDTO[] = [];
  recordsPerPage: number = 10;

  originalPartners: UserPartnerDTO[] = [];
  originalCustomersAvailables: UserPartnerDTO[] = [];
  originalPartnersAvailables: TransferPartnerDTO[] = [];

  filterValue: string = 'option1';

  currentPageAvailables: number = 1;
  currentPage: number = 1;
  currentPagePartnerAvailables: number = 1;


  totalPages: number = 0;
  totalPagesAvailables: number = 0;
  totalPagesPartnerAvailables: number = 0;

  pagesToShow: number = 5;
  pagesToShowAvailables: number = 5;
  pagesToShowPartnerAvailables: number = 5;

  textoBusqueda: string = '';
  textoBusquedaAssignCustomer: string = '';
  textoBusquedaTransferCustomer: string = '';

  camposBusqueda: string[] = [
    'customerAccount',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans'
  ];

  camposBusquedaAvailables: string[] = [
    'idPartner',
    'namePartner',
    'mailPartner',
    'userPhone',
    'phone',
    'totalStaff',
    'totalCustomers',
  ];

  isFilteredByStatus: boolean = false;
  selectedPartner: UserPartnerDTO = {} as UserPartnerDTO;
  isConfirmationModalOpen: boolean = false;
  simpleRequestLongDTO: SimpleRequestDTO = {} as SimpleRequestDTO;
  isAnyCheckboxSelected: boolean = false;
  isAnyCheckboxSelectedPartnerCustomer: boolean = false;
  isAnyCheckboxSelectedTransfer: boolean = false;

  alert: Alert = {} as Alert;

  private partnerService = inject(PartnersService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private alertService = inject(AlertService);
  public permissionsService = inject(ValidatePermissionsService);


  ngOnChanges(c: SimpleChanges) {
    if (c['partnerDataInput']) {
      this.loadCustomers(this.partnerDataInput?.userId);
    }
  }

  loadCustomers(partnerId?: number) {
    if (!partnerId) return;
    this.simpleRequestLongDTO.id = partnerId;
    this.partnerService.getListCustomersByPartnerId(this.simpleRequestLongDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListPartners(Data);
        } else {
          this.HandleMessageError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Partners);
    //this.permissionsService.userHasPermission(MODULE_ID.Customers, [PERMISSION.Read]).subscribe(r => this.allowCustomers = r);
    //this.allowCustomers = this.permissionsService.customers.readPermission;

    this.partnerService.getAllPartnersAvailables().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetAllPartnersAvailables(Data);
        } else {
          this.HandleMessageError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  get pages(): number[] {
    const start = Math.max(
      1,
      this.currentPage - Math.floor(this.pagesToShow / 2)
    );
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  get pageAvailables(): number[] {
    const start = Math.max(
      1,
      this.currentPageAvailables - Math.floor(this.pagesToShowAvailables / 2)
    );
    const end = Math.min(this.totalPagesAvailables, start + this.pagesToShowAvailables - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  get pagePartnerAvailables(): number[] {
    const start = Math.max(
      1,
      this.currentPagePartnerAvailables - Math.floor(this.pagesToShowPartnerAvailables / 2)
    );
    const end = Math.min(this.totalPagesPartnerAvailables, start + this.pagesToShowPartnerAvailables - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  } 

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  changePageAvailables(page: number) {
    if (page >= 1 && page <= this.totalPagesAvailables) {
      this.currentPageAvailables = page;
    }
  }

  changePagePartnerAvailables(page: number) {
    if (page >= 1 && page <= this.totalPagesPartnerAvailables) {
      this.currentPagePartnerAvailables = page;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  previousPageAvailables() {
    if (this.currentPageAvailables > 1) {
      this.currentPageAvailables--;
    }
  }

  previousPagePartnerAvailables() {
    if (this.currentPagePartnerAvailables > 1) {
      this.currentPagePartnerAvailables--;
    }
  }

  nextPage() {
    if (this.currentPage * 10 < this.partners.length) {
      this.currentPage++;
    }
  }

  nextPageAvailables() {
    if (this.currentPageAvailables * 10 < this.customersAvailables.length) {
      this.currentPageAvailables++;
    }
  }

  nextPagePartnerAvailables() {
    if (this.currentPagePartnerAvailables * 10 < this.partnersAvailables.length) {
      this.currentPagePartnerAvailables++;
    }
  }

  getRange(): string {
    const startIndex = (this.currentPage - 1) * 10 + 1;
    const endIndex = Math.min(this.currentPage * 10, this.partners.length);
    return `${startIndex} - ${endIndex}`;
  }

  getRangeAvailables(): string {
    const startIndex = (this.currentPageAvailables - 1) * 10 + 1;
    const endIndex = Math.min(this.currentPageAvailables * 10, this.customersAvailables.length);
    return `${startIndex} - ${endIndex}`;
  }

  HandleMessageError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListPartners(users: UserPartnerDTO[]) {
    this.partners = users;
    this.customersAssigned = users.map(user => ({ ...user }));
    this.originalPartners = this.partners.slice();
    this.partners = this.originalPartners.filter((partner) => partner.userStatus === 0 || partner.userStatus === 1);
    this.totalPages = Math.ceil(this.partners.length / 10);

    this.partnerService.getListCustomersAvailables().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomersAvailables(Data);
        } else {
          this.HandleMessageError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }

  HandleGetListCustomersAvailables(users: UserPartnerDTO[]) {
    this.customersAvailables = users.map(user => ({ ...user }));
    this.customersAssigned.forEach(partner => {
      partner.checked = true;
    });
    
    this.customersAvailables = this.customersAvailables.concat(
      this.customersAssigned.map(partner => ({ ...partner }))
    );

    this.originalCustomersAvailables = this.customersAvailables.slice();
    this.customersAvailables = this.originalCustomersAvailables.filter((partner) => partner.userStatus === 0 || partner.userStatus === 1);
    this.totalPagesAvailables = Math.ceil(this.customersAvailables.length / 10);
  }


  HandleGetAllPartnersAvailables(partners: TransferPartnerDTO[]) {
    partners = partners.filter(partner => partner.idPartner !== this.partnerDataInput?.userId);
    this.partnersAvailables = partners;
    this.originalPartnersAvailables = this.partnersAvailables.slice();
    this.partnersAvailables = this.originalPartnersAvailables;
    this.totalPagesPartnerAvailables = Math.ceil(this.partnersAvailables.length / 10);
  }

  updatePagination(): void {
    if (!this.textoBusqueda) {
      this.totalPages = Math.ceil(this.partners.length / this.recordsPerPage);
    }
  
    const searchCriteria = this.textoBusqueda.split(',').map(criterio => criterio.trim().toLowerCase());
  
    const filteredList = this.partners.filter((item) =>
      this.camposBusqueda.some((field) => {
        const fieldValue = (item as any)[field];
        // Verificamos si el valor del campo no es undefined o null
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some((criterio) => fieldValue.toString().toLowerCase().includes(criterio));
        }
        return false; // Si es undefined o null, lo ignoramos
      })
    );
  
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPage = 1;
  }

  updatePaginationAvailables(): void {
    if (!this.textoBusquedaAssignCustomer) {
      this.totalPagesAvailables = Math.ceil(this.customersAvailables.length / this.recordsPerPage);
    }
  
    const searchCriteria = this.textoBusquedaAssignCustomer.split(',').map(criterio => criterio.trim().toLowerCase());
  
    const filteredList = this.customersAvailables.filter((item) =>
      this.camposBusqueda.some((field) => {
        const fieldValue = (item as any)[field];
        // Verificamos si el valor del campo no es undefined o null
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some((criterio) => fieldValue.toString().toLowerCase().includes(criterio));
        }
        return false; // Si es undefined o null, lo ignoramos
      })
    );
  
    this.totalPagesAvailables = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPageAvailables = 1;
  }

  updatePaginationPartnerAvailables(): void {
    if (!this.textoBusquedaTransferCustomer) {
      this.totalPagesPartnerAvailables = Math.ceil(this.partnersAvailables.length / this.recordsPerPage);
    }
  
    const searchCriteria = this.textoBusquedaTransferCustomer.split(',').map(criterio => criterio.trim().toLowerCase());
  
    const filteredList = this.partnersAvailables.filter((item) =>
      this.camposBusquedaAvailables.some((field) => {
        const fieldValue = (item as any)[field];
        // Verificamos si el valor del campo no es undefined o null
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some((criterio) => fieldValue.toString().toLowerCase().includes(criterio));
        }
        return false; // Si es undefined o null, lo ignoramos
      })
    );
  
    this.totalPagesPartnerAvailables = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPagePartnerAvailables = 1;
  }

  onSearchChange(): void {
    this.updatePagination();
  }

  onsereachChangeAvailables(): void {
    this.updatePaginationAvailables();
  }

  onsereachChangePartnerAvailables(): void {
    this.updatePaginationPartnerAvailables();
  }

  filterByStatus(status: number) {
    this.partners = this.originalPartners.slice(); // Restaura la lista original
    if (!this.isFilteredByStatus) {
      // Guarda la lista original si no se ha filtrado aún
      this.originalPartners = this.partners.slice();
      this.isFilteredByStatus = true;
    }

    this.partners = this.originalPartners.filter((partner) => partner.userStatus === status);
    this.updatePagination();
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.partners = this.originalPartners.slice(); // Restaura la lista original
    this.partners = this.partners.filter(partner => partner.userStatus === 0 || partner.userStatus === 1);
    this.updatePagination();
  }

  setSelectedPartner(user: UserPartnerDTO) {
    this.selectedPartner = user;
  }

  setArchivedPartner(user: UserPartnerDTO) {
    this.selectedPartner = user;
    this.selectedPartner.userStatus = 2;
  }

  toggleStatus(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalPartners.findIndex(cust => cust.customerAccount === customer.customerAccount);
    if (indice !== -1) {
      this.originalPartners[indice].userStatus = customer.userStatus;
    }
  }

  toggleStatusAvailables(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalCustomersAvailables.findIndex(cust => cust.customerAccount === customer.customerAccount);
    if (indice !== -1) {
      this.originalCustomersAvailables[indice].userStatus = customer.userStatus;
    }
  }

  async closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    //location.reload();
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  navigateToPartnerCustomers(user: UserDTO) {
    this.router.navigate(['/partner-customers'], {
      relativeTo: this.route,
      state: { partnerData: user },
    });
  }

    assignCustomers(confirmed: boolean) {
      if(confirmed) {
        let listUserGroup: UserGroupDTO[] = this.customersAvailables
        .map(partner => {
          return {
            AUsrId: partner.customerAccount,
            APartnerId: this.partnerDataInput.userId,
            Checked: partner.checked
          };
        });

        this.partnerService.addCustomersPartner(listUserGroup).subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleAddCustomersPartner(Data);
            } else {
              this.HandleMessageError(StatusCode);
            }
          },
          (error) => {
            console.error('Unexpected error fetching partners list:', error);
          }
        );

      }
      else
      {
        //location.reload();
      }
    }

    transferCustomers(confirmed: boolean) {
      if(confirmed) {

        let selectedPartner = this.partnersAvailables.find(partner => partner.checked);
        let listUserGroup: UserGroupDTO[] = this.originalPartners
        .filter(partner => partner.checked)
        .map(partner => {
          return {
            AUsrId: partner.customerAccount,
            APartnerId: selectedPartner?.idPartner
          };
        });

        this.partnerService.updateCustomersPartner(listUserGroup).subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleTransfer(Data);
            } else {
              this.HandleMessageError(StatusCode);
            }
          },
          (error) => {
            console.error('Unexpected error fetching partners list:', error);
          }
        );

      }
      else
      {
        //location.reload();
      }
    }

    HandleAddCustomersPartner(StatusCode: boolean) {
      this.alert = {
        alertMessage: 'Customers added successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };

      this.alertService.updateAlertState(
        this.alert
      );

      this.ngOnInit();
    }

    HandleTransfer(StatusCode: boolean) {
      this.alert = {
        alertMessage: 'Customers transfered successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };

      this.alertService.updateAlertState(
        this.alert
      );

      this.ngOnInit();
    }

    checkboxChanged(): void {
      this.isAnyCheckboxSelected = this.customersAvailables.some(partner => partner.checked);
    }

    checkboxChangedPartnerCustomer(): void {
      this.isAnyCheckboxSelectedPartnerCustomer = this.partners.some(partner => partner.checked);
    }

    checkboxChangedTransfer(selectedPartner: TransferPartnerDTO): void {
      this.partnersAvailables.forEach(partner => {
        partner.checked = false;
      });
    
      const selected = this.partnersAvailables.find(partner => partner === selectedPartner);
      if (selected) {
        selected.checked = true;
      }
    
      this.isAnyCheckboxSelectedTransfer = selected !== undefined;
    }

    selectAllCheckboxes(event: any): void {
      const isChecked = event.target.checked;
      this.customersAvailables.forEach(partner => {
        partner.checked = isChecked;
      });
      this.isAnyCheckboxSelected = this.customersAvailables.some(partner => partner.checked);
    }

    selectAllCheckboxesPartnerCustomer(event: any): void {
      const isChecked = event.target.checked;
      this.partners.forEach(partner => {
        partner.checked = isChecked;
      });
      this.isAnyCheckboxSelectedPartnerCustomer = this.partners.some(partner => partner.checked);
    }

    selectAllCheckboxesTransfer(event: any): void {
      const isChecked = event.target.checked;
      this.partnersAvailables.forEach(partner => {
        partner.checked = isChecked;
      });
      this.isAnyCheckboxSelectedTransfer = this.partnersAvailables.some(partner => partner.checked);
    }

    exportToExcelListPartnerCustomers() {
      this.partnerService.exportToExcelListPartnerCustomers(this.simpleRequestLongDTO).subscribe(
        (response: ResponseDataFile) => {
          if (response) {
            this.handleDownload(response);
          } else {
            this.handleGetFileError();
          }
        },
        (error) => {
          console.error('Error al exportar el archivo Excel:', error);
        }
      );
    }
  
    private handleDownload(data: ResponseDataFile) {
      const byteCharacters = atob(data.Data.fileContents);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: data.Data.contentType });
      saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');
  
      this.alert = {
        alertMessage: 'File generated successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(
        this.alert
      );
    }
  
    private handleGetFileError() {
      this.alert = {
        alertMessage: 'Unexpected error. Please try again later.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      this.alertService.updateAlertState(
        this.alert
      );
    }
}
